import type { JsonValue } from '../serializable';

/** Merges webhook JSON fields over trigger defaults so agent `prompt` etc. are overridden. */
export function buildWebhookRunInput(
  defaultInput: unknown,
  request: unknown
): { [key: string]: JsonValue } {
  const base = toJsonObject(defaultInput);
  const payloadFields =
    typeof request === 'object' && request !== null && !Array.isArray(request)
      ? toJsonObject(request)
      : {};
  return {
    ...base,
    ...payloadFields,
    webhookPayload: toJsonValue(request),
  };
}

export function toJsonObject(value: unknown): { [key: string]: JsonValue } {
  if (value === null) {
    return {};
  }
  if (Array.isArray(value)) {
    return {};
  }
  if (typeof value !== 'object') {
    return {};
  }

  const output: { [key: string]: JsonValue } = {};
  for (const [key, entryValue] of Object.entries(value)) {
    output[key] = toJsonValue(entryValue);
  }
  return output;
}

function toJsonValue(value: unknown): JsonValue {
  if (value === null) {
    return null;
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((entryValue) => toJsonValue(entryValue));
  }
  if (typeof value === 'object') {
    const output: { [key: string]: JsonValue } = {};
    for (const [key, entryValue] of Object.entries(value)) {
      output[key] = toJsonValue(entryValue);
    }
    return output;
  }
  return String(value);
}
